import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import FormSection from "components/sales/formSection/formSection";
import LabelInput from "components/sales/Input/labelInput/labelInput";
import { DatePickerInput } from "rc-datepicker";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import CostPerSlot from "components/sales/formSection/costPerSlot/costPerSlot";
import Contact from "components/sales/formSection/contact/contact";
import { FormGroup } from "react-bootstrap";

const TeamType = ({
  label,
  partnerDate,
  deliveryDate,
  poc,
  escalationContact,
  costPerSlot,
  supply,
  handleValue,
}) => {
  const inputs = {
    partner_desired_date: new Date(),
    delivery_date: new Date(),
  };
  const [formData, setData] = useState(inputs);
  const [isFocus1, setIsFous1] = useState(false);
  const [isFocus2, setIsFous2] = useState(false);

  const teamInput = {
    contactPoc: null,
    contactEscalation: null,
  };
  const [teamData, setTeamData] = useState(teamInput);
  const handlePartnerDateChange = (jsdate, dateString) => {
    setData({ ...formData, partner_desired_date: jsdate });
  };
  const handleDeliveryDateChange = (jsdate, dateString) => {
    setData({ ...formData, delivery_date: jsdate });
  };
  const handlePoc = (val) => {
    setTeamData({ ...teamData, contactPoc: val });
  };
  const handleEscalation = (val) => {
    setTeamData({ ...teamData, contactEscalation: val });
  };
  const handleData = () => {
    if (supply === "true") {
      let supply_team_data = [
        {
          partner_desired_date: formData.partner_desired_date,
          delivery_date: formData.delivery_date,
          poc:
            teamData.contactPoc && teamData.contactPoc.poc
              ? teamData.contactPoc.poc
              : null,
          escalation_contact:
            teamData.contactEscalation &&
            teamData.contactEscalation.escalation_contact
              ? teamData.contactEscalation.escalation_contact
              : null,
        },
      ];
      handleValue({ supply_team_data: supply_team_data });
    } else {
      let product_team_data = [
        {
          partner_desired_date: formData.partner_desired_date,
          delivery_date: formData.delivery_date,
          poc:
            teamData.contactPoc && teamData.contactPoc.poc
              ? teamData.contactPoc.poc
              : null,
          escalation_contact:
            teamData.contactEscalation &&
            teamData.contactEscalation.escalation_contact
              ? teamData.contactEscalation.escalation_contact
              : null,
        },
      ];
      handleValue({ product_team_data: product_team_data });
    }
  };

  useEffect(() => {
    handleData();
  }, [formData, teamData]);

  const handleDateHide1 = () => {
    if (!formData.partner_desired_date) {
      setIsFous1(false);
    } else setIsFous1(true);
  };
  const handleDateHide2 = () => {
    if (!formData.delivery_date) {
      setIsFous2(false);
    } else setIsFous2(true);
  };

  return (
    <FormSection title={label}>
      <FormGroup
        className={`date custom_date_picker ${isFocus1 ? "active-date" : ""}`}
      >
        <DatePickerInput
          onChange={handlePartnerDateChange}
          value={formData.partner_desired_date}
          onShow={() => setIsFous1(true)}
          onHide={handleDateHide1}
          onClear={() => setIsFous1(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          displayFormat="DD-MM-YYYY"
          returnFormat="DD-MM-YYYY"
          className="my-custom-datepicker-component"
        />
        <label>{partnerDate}</label>
      </FormGroup>
      <FormGroup
        className={`date custom_date_picker ${isFocus2 ? "active-date" : ""}`}
      >
        <DatePickerInput
          onChange={handleDeliveryDateChange}
          value={formData.delivery_date}
          onShow={() => setIsFous2(true)}
          onHide={handleDateHide2}
          onClear={() => setIsFous2(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          displayFormat="DD-MM-YYYY"
          returnFormat="DD-MM-YYYY"
          className="my-custom-datepicker-component"
        />
        <label>{deliveryDate}</label>
      </FormGroup>
      <Contact
        title={localization.poc}
        name={localization.name}
        phone={localization.contact}
        handleValue={handlePoc}
        poc="true"
      />
      <Contact
        title={localization.escalContact}
        name={localization.name}
        phone={localization.contact}
        handleValue={handleEscalation}
        poc="false"
      />
      {/* { supply === "true" ?
                <CostPerSlot /> : null
            } */}
    </FormSection>
  );
};

TeamType.propTypes = {};

export default TeamType;
